import { render, staticRenderFns } from "./AnalyticsDetailScreen-new.vue?vue&type=template&id=1d1a5451&scoped=true&lang=pug"
import script from "./AnalyticsDetailScreen-new.vue?vue&type=script&lang=ts"
export * from "./AnalyticsDetailScreen-new.vue?vue&type=script&lang=ts"
import style0 from "./AnalyticsDetailScreen-new.vue?vue&type=style&index=0&id=1d1a5451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a5451",
  null
  
)

export default component.exports